import React from 'react';
/* eslint-disable */
export function ArrowLeftGradient(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none" {...props}>
      <path
        d="M15 7C15 6.3125 14.4375 5.75 13.75 5.75H5.15625L7.90625 2.875C8.375 2.375 8.34375 1.59375 7.84375 1.09375C7.34375 0.625 6.5625 0.65625 6.09375 1.15625L1.34375 6.15625C0.875 6.625 0.875 7.40625 1.34375 7.875L6.09375 12.875C6.3125 13.125 6.65625 13.25 7 13.25C7.28125 13.25 7.59375 13.1562 7.84375 12.9062C8.34375 12.4375 8.375 11.6562 7.90625 11.1562L5.15625 8.25H13.75C14.4375 8.25 15 7.71875 15 7Z"
        fill="url(#paint0_linear_969_37969)"
      />
      <defs>
        <linearGradient id="paint0_linear_969_37969" x1="1" y1="7" x2="15" y2="7" gradientUnits="userSpaceOnUse">
          <stop stopColor="#DD2476" />
          <stop offset="1" stopColor="#FF512F" />
        </linearGradient>
      </defs>
    </svg>
  );
}
